import { getAuthHeader } from '.';
import { ROOT_URL } from '../utils/constants';

class CommonApi {
  static async getColors() {
    const [headers] = await getAuthHeader();
    const response = await fetch(`${ROOT_URL}/api/colors`, {
      method: 'GET',
      credentials: 'include',
      headers: headers,
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
  static async getGenders() {
    const [headers] = await getAuthHeader();
    const response = await fetch(`${ROOT_URL}/api/genders`, {
      method: 'GET',
      credentials: 'include',
      headers: headers,
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
  static async getBreeds() {
    const [headers] = await getAuthHeader();
    const response = await fetch(`${ROOT_URL}/api/breeds`, {
      method: 'GET',
      credentials: 'include',
      headers: headers,
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
  static async getStates() {
    const [headers] = await getAuthHeader();
    const response = await fetch(`${ROOT_URL}/api/states`, {
      method: 'GET',
      credentials: 'include',
      headers: headers,
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
}

export default CommonApi;
